/* tslint:disable */
/* eslint-disable */
/* @relayHash 4a092f6fd905f182c4951d1e0365de43 */

import { ConcreteRequest } from "relay-runtime";
export type SiteSearchDropdownQueryVariables = {};
export type SiteSearchDropdownQueryResponse = {
    readonly sites: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly name: string;
            };
        }>;
    };
};
export type SiteSearchDropdownQuery = {
    readonly response: SiteSearchDropdownQueryResponse;
    readonly variables: SiteSearchDropdownQueryVariables;
};



/*
query SiteSearchDropdownQuery {
  sites {
    edges {
      node {
        id
        name
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "SitesConnection",
            "kind": "LinkedField",
            "name": "sites",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "SiteEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Site",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "SiteSearchDropdownQuery",
            "selections": (v0 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "SiteSearchDropdownQuery",
            "selections": (v0 /*: any*/)
        },
        "params": {
            "id": "4a092f6fd905f182c4951d1e0365de43",
            "metadata": {},
            "name": "SiteSearchDropdownQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = 'f1f34091d140f21e3da80f8298430e12';
export default node;
